import axiosInstance from "app/axiosInstance";
import { KeysRequestDto } from "../entities/dtos/keys-request.dto";

export const getKeys = async (payload: KeysRequestDto) => {
  try {
    const { accountId } = payload;
    const response = await axiosInstance.get(`/accounts/${accountId}/keys`);

    if (response.status === 200) {
      return response.data;
    }

    return [];
  } catch (e: any) {
    console.error(e);
    throw e;
  }
};
